module.exports = __webpack_public_path__ + "static/media/e-sports3.41a5d61f.jpg";